import { TableContainer } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Action from "components/ActionPopOver";
import Loader from "components/loader/Loader";
import { formatDate } from "helper/dateFormat";
import React from 'react';
import { fontConfig } from "theme/fontConfig";


const TableCellHead = withStyles((theme) => ({
  root: {
    height: "39px",
    padding: "0px 20px",
    borderBottom: "none",
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
    paddingLeft: "20px !important",
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: "65px",
    padding: "0px 20px",
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
    fontSize: "12px",
    color: "#4F4F4F",
  },
}))(TableCell);


const EventTypeTable = ({
  loading,
  eventtypeList,
  openEditEvent,
  deleteEvent
}) => {
  console.log('eventtypeList :', eventtypeList);


  const columns = [
    {
      id: "name",
      label: "NAME",
    },
    {
      id: "description",
      label: "DESCRIPTION",
    },
    {
      id: "created_by",
      label: "CREATED/EDITED BY",
    },
    {
      id: "created_date",
      label: "DATE CREATED",
    },
    {
      id: "action",
      label: "ACTION",
      className: "sticky-header-column",
    }
  ];

  return (
    <TableContainer className="scroll-table">
      <Table
        class="main-tables"
        aria-label="collapsible table"
        style={{ width: "100%" }}
      >
        <TableHead className="charges-table sticky-table-header">
          <TableRow>
            {columns?.map((column) => (
              <TableCellHead
                key={column.id}
                align="left" 
                className={`class__header__cell year__head ${column.className}`}
              >
                <div className="d-flex h-100 justify-content-start align-items-center" style={{ gap: "10px" }}>
                  {column?.id !== "action" && column.label}
                </div>
              </TableCellHead>
            ))}
          </TableRow>
        </TableHead>
        <TableBody
          className="tran-table-body"
          style={{
            backgroundColor: "white",
          }}
        >
          {loading ? (
            <TableRow>
              <TableCell colSpan={10} align="center">
                <div
                  className="user__loader"
                  style={{ height: "320px" }}
                >
                  <Loader />
                </div>
              </TableCell>
            </TableRow>
          ) : eventtypeList?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={10} align="center">
                <h6 style={{ height: "320px", marginTop: "100px" }}>
                  No Data Found
                </h6>
              </TableCell>
            </TableRow>
          ) : (
            eventtypeList?.map((row, i) => (
              <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                <TableCellBody align="left">{row?.name}</TableCellBody>
                <TableCellBody align="left">{(row?.description && row?.description !== "undefined") ? row?.description : "-"}</TableCellBody>
                <TableCellBody align="left">{row?.changed_by}</TableCellBody>
                <TableCellBody align="left">{formatDate({ date: row?.changed, formatType: "default" })}</TableCellBody>
                <TableCellBody className="sticky-body-column" align="right">
                  <div style={{ cursor: "pointer", paddingleft: "0px" }}>
                    <Action
                      action='class'
                      style={{ width: '16px' }}
                      onEditClick={() => openEditEvent(row)}
                      onClassDeleteClick={() => deleteEvent(row)}
                    />
                  </div>
                </TableCellBody>
              </TableRow>
            )
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default EventTypeTable